// extracted by mini-css-extract-plugin
module.exports = {"container":"UgcActions_container___cgvF","completedContainer":"UgcActions_completedContainer__LSZvO","action":"UgcActions_action__o9XfE","dot":"UgcActions_dot__rhZne"};